<template>

  <t-dialog-form :generalErrors="generalErrors" large :title="t(command) + ' Item'"
                 :ok-text="t(command) + ' Item'"
                 @show="showModal" @hidden="resetModal" :busy="busy" :id="id"
                 :status="status" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">


    <t-input v-model="form.quoteOccurrenceId" hidden/>

    <b-row>

      <t-input v-if="!isInsert()" cols="8" v-model="usingName" label="Item"/>

      <b-col v-else cols="8">

        <t-input-code-label type-checklist-item
                            :status="status"
                            :command="command"
                            required
                            v-model="form.typeChecklistItemId"/>

      </b-col>

      <t-input fixed cols="4" v-model="place" label="Local"/>

    </b-row>

    <b-row>

      <b-col cols="8">

        <t-input-code-label environment @onResume="onResumeEnvironment"
                            :block-enterprise-id="enterpriseId"
                            :status="status"
                            :command="command"
                            :fixed="!isInsert() && !isUpdate()"
                            required
                            :add-error="error.environmentId"
                            v-model="form.environmentId"/>

      </b-col>

      <b-col cols="4">

        <t-input-code-label type-pathology
                            :status="status"
                            :command="command"
                            required
                            v-model="form.typePathologyId"/>

      </b-col>

    </b-row>


    <!--    <b-row>




          <t-input cols="4" fixed v-model="form.environment" label="Ambiente"/>

          <t-input cols="4" fixed v-model="form.typePathologyAutomatically" label="Anomalia"/>


        </b-row>-->

    <b-row>

      <!--
            <b-col cols="4">


             <label>Apontamento</label> <br/>

              <b-button
                  :to="{path: '/checklist/occurrence/'+form.occurrenceNumber}"
                  size="sm"
                  variant="outline-primary" target="_blank">
                <b-icon-box-arrow-up-right class="mr-2"/>
                {{ form.occurrenceCodeLabel }}
              </b-button>



            </b-col>
      -->
      <t-input cols="2" v-model="form.quantity" @change="updateTotals()" number :decimals="4"
               ref="input_quantity"
               label="Qtd." required/>

      <t-input v-model="form.unit" select-common :options="UnitType.list" cols="2" label="Un. Medida" required/>

      <t-input cols="2" v-model="form.unitPrice" @change="updateTotals()" money
               label="Valor Un."/>

      <t-input cols="2" v-model="form.totalPriceSale" highlight fixed money
               label="Valor Total"/>

    </b-row>

    <b-row>

      <b-col cols="6">

        <b-form-checkbox v-model="form.enableCost" switch>
          Detalhar custo?
          <t-help title="Marque, caso desejar detalhar as informações de custo."/>
        </b-form-checkbox>

      </b-col>


      <b-col cols="6">

        <b-form-checkbox v-model="form.budgetAccepted" switch>
          Item autorizado pelo cliente?
          <t-help title="Desmarque, caso desejar reprovar e por tanto excluir este item individualmente do orçamento."/>
        </b-form-checkbox>

      </b-col>


    </b-row>


    <div v-if="form.enableCost">

      <b-card-title class="mt-3">Informações de Custo</b-card-title>


      <b-row>

        <t-input cols="2" v-model="form.unitCostMaterial" @change="updateTotals()" money
                 label="Vl. Un. Material"/>

        <t-input cols="2" v-model="form.totalCostMaterial" fixed money
                 label="Vl. Total Material"/>

        <t-input cols="2" v-model="form.unitCostLabor" @change="updateTotals()" money
                 label="Vl. Un. MO"/>

        <t-input cols="2" v-model="form.totalCostLabor" fixed money
                 label="Valor Total MO"/>

        <t-input cols="2" v-model="form.unitInvoiceTax" @change="updateTotals()" percent
                 label="NF (%)"/>


        <t-input cols="2" v-model="form.totalPriceInvoiceTax" fixed money
                 label="Valor NF"/>


      </b-row>

      <b-row class="mb-2">

        <b-col cols="10">


        </b-col>

        <b-col cols="2" class="d-flex align-content-end justify-content-end">

          <b-form-checkbox v-model="form.enableDirectBilling" @change="updateTotals()" switch>
            Fat. direto?
            <t-help
                title="Marque caso desejar que o cálculo do Valor NF seja (Valor Total do Serviço - Valor Total Material) X Alíquota de NF unitária. Por padrão o valor total de impostos será Valor Total do Serviço X Alíquota de NF"/>
          </b-form-checkbox>

        </b-col>

      </b-row>


      <b-row>


        <t-input cols="2" v-model="form.unitCompanyExpense" @change="updateTotals()" percent
                 label="Outros (%)"/>

        <t-input cols="2" v-model="form.totalPriceCompanyExpense" fixed money
                 label="Valor Outros"/>

        <t-input cols="2" v-model="form.unitOtherExpense" @change="updateTotals()" percent
                 label="BDI (%)"/>

        <t-input cols="2" v-model="form.totalPriceOtherExpense" fixed money
                 label="Valor BDI"/>

        <t-input cols="2" v-model="form.markupPercentage" fixed percent
                 label="Margem Lucro"/>

        <t-input cols="2" v-model="form.totalPriceProfit" fixed money
                 label="Lucro Líquido"/>


        <!--              <t-input cols="2" v-model="form.note"
                               label="Obs." max-length="2000"/>-->


      </b-row>


    </div>


  </t-dialog-form>


</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import UnitType from "@/model/types/modules/general/UnitType";
import SectorService from "@/services/modules/agent/Sector.service";


export default {
  name: 'QuoteOccurrenceDialog',
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      UnitType,
      id: "modal-quote-occurrence",
      path: "business/quote-occurrence", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "quoteOccurrenceId",
      foreignKeyColumn: "quoteId", //Utilizar quando usar Tabs com outros componentes
      form: {
        quoteId: this.foreignKey,
        quoteOccurrenceId: this.quoteOccurrenceId,
        occurrenceId: 0,
        quantity: 1,
        enableCost: false,
        enableDirectBilling: false,
        unitPrice: 0.0,
        unitCostMaterial: 0.0,
        unitCostLabor: 0.0,
        unitInvoiceTax: 0.0,
        unitCompanyExpense: 0.0,
        unitOtherExpense: 0.0,
        totalCostMaterial: 0.0,
        totalCostLabor: 0.0,
        totalPriceSale: 0.0,
        changedName: "",
        totalPriceInvoiceTax: 0.0,
        totalPriceCompanyExpense: 0.0,
        totalPriceOtherExpense: 0.0,
        markupPercentage: 0.0,
        totalPriceCost: 0.0,
        totalPriceProfit: 0.0,
        unit: "",
        budgetAccepted: true,
        note: "",
        status: 1,
        environmentId: 0,
        typeChecklistItemId: 0,
        typePathologyId: 0, //Apelação Cymaco
      },
      error: {//Campos que podem receber retorno de erro do backend
        occurrenceId: "",
      },

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      sectorOptions: [],
      place: "",
      usingName: "",
      environmentResume: {
        environmentId: 0,
        environmentCodeLabel: "",
        spotFolderId: 0,
        enterpriseId: 0,
        enterpriseDivisionId: 0,
        division: "",
        name: "",
        spotFolder: "",
        enterprise: "",
      }
    }
  },
  props: {
    enterpriseId: {
      type: Number,
      default: 0
    },
    customerId: {
      type: Number,
      required: false,
      default: 0,
    },
    companyId: {
      type: Number,
      required: false,
      default: 0,
    },
    quoteOccurrenceId: {
      type: Number,
      required: false,
      default: 0,
    }
  },
  async mounted() {

    await SectorService.selectList().then((list) => {
      this.sectorOptions = list
    }).catch(error => this.responseError(error))

  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {


      this.busy = true

      //Limpa os campos
      this.resetModal()


      //Setar alguma informações padrão por exemplo vindo de fora
      this.form.quoteOccurrenceId = this.quoteOccurrenceId
      this.form.quoteId = this.foreignKey
      this.form.budgetAccepted = true
      this.form.enableCost = true
      this.form.unit = "m²"
      this.form.typePathologyId = 1262 //Apelação Cymaco
      this.form.status = 1


      await this.readModal(false)


      this.usingName = this.form.typeChecklistItem


      this.busy = false

    },

    async onSubmit() {

      if (this.form.originalTypeChecklistItem !== this.usingName) {
        this.form.changedName = this.usingName
      } else {
        this.form.changedName = ""
      }

      await this.setSubmitDialogDefault()

    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    updateTotals() {


      //Atualiza o valor total de venda
      this.form.totalPriceSale = this.form.unitPrice * this.form.quantity

      this.form.totalCostMaterial = this.form.quantity * (this.form.unitCostMaterial)
      this.form.totalCostLabor = this.form.quantity * (this.form.unitCostLabor)
      this.form.totalPriceOtherExpense = this.form.totalPriceSale * (this.form.unitOtherExpense / 100)
      this.form.totalPriceCompanyExpense = this.form.totalPriceSale * (this.form.unitCompanyExpense / 100)

      if (this.form.enableDirectBilling) {
        this.form.totalPriceInvoiceTax = (this.form.totalPriceSale - this.form.totalCostMaterial) * (this.form.unitInvoiceTax / 100)
      } else {
        this.form.totalPriceInvoiceTax = this.form.totalPriceSale * (this.form.unitInvoiceTax / 100)
      }

      this.form.totalPriceCost = this.form.totalCostMaterial + this.form.totalCostLabor + this.form.totalPriceInvoiceTax + this.form.totalPriceCompanyExpense + this.form.totalPriceOtherExpense
      this.form.totalPriceProfit = this.form.totalPriceSale - this.form.totalPriceCost


      if (this.form.unitPrice > 0) {
        this.form.markupPercentage = (this.form.totalPriceProfit / this.form.totalPriceSale) * 100
      } else {
        this.form.markupPercentage = 0
      }


    },

    setUnitPriceDefault(value) {

      //Sempre irá trazer do apontamento original
      if (this.objValid(value.budgetUnit) && value.budgetUnit !== "") {
        this.form.unit = value.budgetUnit
      }

      if (this.form.unitPrice === 0 && (this.objValid(value.saleValueDefault) && value.saleValueDefault !== 0)) {
        this.form.unitPrice = value.saleValueDefault
      }
    },

    onResumeEnvironment(resume) {

      this.environmentResume = resume
      this.place = this.environmentResume.division + ' - ' + this.environmentResume.spotFolder

    },


    //--------------------------------------------------------------------------------------
  },
}
</script>
